/**
 * @generated SignedSource<<dcb1bed26c17a3f7074c316da0651409>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MATUserOrganizationCreateDialog_matOrganization$data = {
  readonly id: string;
  readonly " $fragmentType": "MATUserOrganizationCreateDialog_matOrganization";
};
export type MATUserOrganizationCreateDialog_matOrganization$key = {
  readonly " $data"?: MATUserOrganizationCreateDialog_matOrganization$data;
  readonly " $fragmentSpreads": FragmentRefs<"MATUserOrganizationCreateDialog_matOrganization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MATUserOrganizationCreateDialog_matOrganization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "MATOrganization",
  "abstractKey": null
};

(node as any).hash = "e37ef9584aaae29effce5967b594b8eb";

export default node;
